import { createContext, type PropsWithChildren, useContext } from 'react';

import type { StopDetails } from '#domain/Stop.ts';
import type { Tour } from '#domain/Tour.ts';

type TourStopContextType = {
    selectedTour: Tour;
    selectedTourStops: StopDetails[] | undefined;
};

const TourStopContext = createContext<TourStopContextType>({} as unknown as TourStopContextType);

export const useTourStopContext = () => useContext<TourStopContextType>(TourStopContext);

export const TourStopContextProvider = ({
    selectedTour,
    selectedTourStops,
    children,
}: PropsWithChildren<TourStopContextType>) => (
    <TourStopContext value={{ selectedTour, selectedTourStops }}>{children}</TourStopContext>
);
